import produce from "immer";
import { IStoreState } from "../initialStoreState";
import { LoadState } from "../../constants/enums";
import { LeadsActions } from ".";
import {
  initialLead,
  initialLeadState,
  initialRoughEstimate,
} from "./leads.types";
import {
  CLEAR_LEAD,
  CLEAR_LEAD_STATE,
  CLEAR_ROUGH_ESTIMATE,
  CLEAR_ROUGH_ESTIMATE_STATE,
  FETCH_DRIVE_STATUS_CATEGORY_LIST_FAILED,
  FETCH_DRIVE_STATUS_CATEGORY_LIST_PROGRESS,
  FETCH_DRIVE_STATUS_CATEGORY_LIST_SUCCESS,
  FETCH_DRIVE_STATUS_LIST_FAILED,
  FETCH_DRIVE_STATUS_LIST_PROGRESS,
  FETCH_DRIVE_STATUS_LIST_SUCCESS,
  FETCH_LEADS_LIST_FAILED,
  FETCH_LEADS_LIST_PROGRESS,
  FETCH_LEADS_LIST_STATUS_COUNT_FAILED,
  FETCH_LEADS_LIST_STATUS_COUNT_PROGRESS,
  FETCH_LEADS_LIST_STATUS_COUNT_SUCCESS,
  FETCH_LEADS_LIST_SUCCESS,
  FETCH_LEAD_FAILED,
  FETCH_LEAD_PROGRESS,
  FETCH_LEAD_STATUS_COUNT_FAILED,
  FETCH_LEAD_STATUS_COUNT_PROGRESS,
  FETCH_LEAD_STATUS_COUNT_SUCCESS,
  FETCH_LEAD_SUCCESS,
  FETCH_ROUGH_ESTIMATE_FAILED,
  FETCH_ROUGH_ESTIMATE_PROGRESS,
  FETCH_ROUGH_ESTIMATE_SUCCESS,
  FETCH_WHATSAPP_STATUS_UNREPLIED_COUNT_FAILED,
  FETCH_WHATSAPP_STATUS_UNREPLIED_COUNT_PROGRESS,
  FETCH_WHATSAPP_STATUS_UNREPLIED_COUNT_SUCCESS,
} from "./leadsActions";

export const leadsReducer = (
  state: IStoreState["leads"] = initialLeadState,
  action: LeadsActions
) => {
  switch (action.type) {
    case FETCH_LEADS_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.list.loading = LoadState.InProgress;
        draftState.list.list = [];
        draftState.list.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_LEADS_LIST_SUCCESS: {
      const { list, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.list.loading = LoadState.Loaded;
        draftState.list.list = list;
        draftState.list.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_LEADS_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.list.loading = LoadState.Failed;
        draftState.list.list = [];
        draftState.list.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_LEAD_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.lead.loading = LoadState.InProgress;
        draftState.lead.data = initialLead;
      });
      return newState;
    }
    case FETCH_LEAD_SUCCESS: {
      const { lead } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.lead.loading = LoadState.Loaded;
        draftState.lead.data = lead;
      });
      return newState;
    }
    case FETCH_LEAD_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.lead.loading = LoadState.Failed;
        draftState.lead.error = errorMessage;
      });
      return newState;
    }
    case CLEAR_LEAD: {
      const newState = produce(state, (draftState) => {
        draftState.lead.loading = LoadState.NotLoaded;
        draftState.lead.data = initialLead;
      });
      return newState;
    }

    case FETCH_LEAD_STATUS_COUNT_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.recordCounts.loading = LoadState.InProgress;
        draftState.recordCounts.list = [];
      });
      return newState;
    }
    case FETCH_LEAD_STATUS_COUNT_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.recordCounts.loading = LoadState.Loaded;
        draftState.recordCounts.list = data;
      });
      return newState;
    }
    case FETCH_LEAD_STATUS_COUNT_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.recordCounts.loading = LoadState.Failed;
        draftState.recordCounts.list = [];
      });
      return newState;
    }

    case FETCH_LEADS_LIST_STATUS_COUNT_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.list.loading = LoadState.InProgress;
        draftState.list.list = [];
        draftState.list.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_LEADS_LIST_STATUS_COUNT_SUCCESS: {
      const { list, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.list.loading = LoadState.Loaded;
        draftState.list.list = list;
        draftState.list.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_LEADS_LIST_STATUS_COUNT_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.list.loading = LoadState.InProgress;
        draftState.list.list = [];
        draftState.list.totalRecords = 0;
      });
      return newState;
    }

    case FETCH_ROUGH_ESTIMATE_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.roughEstimate.loading = LoadState.InProgress;
        draftState.roughEstimate.data = [];
      });
      return newState;
    }
    case FETCH_ROUGH_ESTIMATE_SUCCESS: {
      const { roughEstimates } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.roughEstimate.loading = LoadState.Loaded;
        draftState.roughEstimate.data = roughEstimates;
      });
      return newState;
    }
    case FETCH_ROUGH_ESTIMATE_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.roughEstimate.loading = LoadState.Failed;
        draftState.roughEstimate.error = errorMessage;
      });
      return newState;
    }
    case CLEAR_ROUGH_ESTIMATE: {
      const newState = produce(state, (draftState) => {
        draftState.roughEstimate.loading = LoadState.NotLoaded;
        draftState.roughEstimate.data = [];
      });
      return newState;
    }

    case FETCH_WHATSAPP_STATUS_UNREPLIED_COUNT_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.whatsappStatusUnrepliedCounts.loading = LoadState.InProgress;
        draftState.whatsappStatusUnrepliedCounts.list = [];
      });
      return newState;
    }
    case FETCH_WHATSAPP_STATUS_UNREPLIED_COUNT_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.whatsappStatusUnrepliedCounts.loading = LoadState.Loaded;
        draftState.whatsappStatusUnrepliedCounts.list = data;
      });
      return newState;
    }
    case FETCH_WHATSAPP_STATUS_UNREPLIED_COUNT_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.whatsappStatusUnrepliedCounts.loading = LoadState.Failed;
        draftState.whatsappStatusUnrepliedCounts.list = [];
      });
      return newState;
    }

    case FETCH_DRIVE_STATUS_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.driveStatusList.loading = LoadState.InProgress;
        draftState.driveStatusList.list = [];
      });
      return newState;
    }
    case FETCH_DRIVE_STATUS_LIST_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.driveStatusList.loading = LoadState.Loaded;
        draftState.driveStatusList.list = data;
      });
      return newState;
    }
    case FETCH_DRIVE_STATUS_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.driveStatusList.loading = LoadState.Failed;
        draftState.driveStatusList.list = [];
      });
      return newState;
    }

    case FETCH_DRIVE_STATUS_CATEGORY_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.driveStatusCategoryList.loading = LoadState.InProgress;
        draftState.driveStatusCategoryList.list = [];
      });
      return newState;
    }
    case FETCH_DRIVE_STATUS_CATEGORY_LIST_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.driveStatusCategoryList.loading = LoadState.Loaded;
        draftState.driveStatusCategoryList.list = data;
      });
      return newState;
    }
    case FETCH_DRIVE_STATUS_CATEGORY_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.driveStatusCategoryList.loading = LoadState.Failed;
        draftState.driveStatusCategoryList.list = [];
      });
      return newState;
    }

    case CLEAR_LEAD_STATE: {
      return initialLeadState;
    }

    case CLEAR_ROUGH_ESTIMATE_STATE: {
      return initialLeadState;
    }

    default: {
      return state;
    }
  }
};
